export const formatCurrency = (value: number | string | undefined | null): string => {
    if (value === null || value === undefined) return 'R$ 0,00';
    if (typeof value === 'string' && value.trim() === '') return 'R$ 0,00';
    const numValue = typeof value === 'string' ? parseFloat(value.replace(',', '.')) : value;
    if (isNaN(numValue)) return 'R$ 0,00';
    return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL'
    }).format(numValue);
};
